module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapClass imageselect"
  }, [(_vm.hasClose) ? _c('span', {
    staticClass: "imageselect-close",
    on: {
      "click": _vm.handleClose
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.hasLabel) ? _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fg-line",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.imageLoading),
      expression: "imageLoading"
    }],
    attrs: {
      "element-loading-text": _vm.loadingText
    }
  }, [_c('img', {
    staticClass: "jc-border-color",
    style: (_vm.imageStyle),
    attrs: {
      "src": _vm.imageDate
    },
    on: {
      "click": _vm.clickOntheImage
    }
  })]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*,image/bmp, image/gif, image/jpeg,image/x-png",
      "id": "fileHeadImg"
    }
  }), _vm._v(" "), _vm._t("rightContent")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e240a9ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/imageselect.vue
// module id = 559
// module chunks = 23